import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["value", "tagsWrapperClassName", "id"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _map from 'lodash/map';
import _reject from 'lodash/reject';
import _noop from 'lodash/noop';
import _castArray from 'lodash/castArray';
import _uniqBy from 'lodash/uniqBy';
import _isObject from 'lodash/isObject';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import Tag from '../../../../atoms/Tag';
import styles from './withTags.module.scss';
export default function (WrapperComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_React$Component) {
    _inherits(_withTags, _React$Component);
    var _super = _createSuper(_withTags);
    function _withTags() {
      var _this;
      _classCallCheck(this, _withTags);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "removeTag", function (value) {
        return function () {
          var _this$props = _this.props,
            currValue = _this$props.value,
            onChange = _this$props.onChange;
          onChange(_reject(currValue, ['value', value]), {});
        };
      });
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (values, eventDetails) {
        var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value;
        onChange(_uniqBy([].concat(_toConsumableArray(value), _toConsumableArray(_castArray(values))), 'value'), eventDetails);
      });
      _defineProperty(_assertThisInitialized(_this), "renderTag", function (selectedValue) {
        var _this$props3 = _this.props,
          areTagsDeletable = _this$props3.areTagsDeletable,
          tagClassName = _this$props3.tagClassName,
          id = _this$props3.id;
        if (!_isObject(selectedValue) || !selectedValue) return null;
        return /*#__PURE__*/React.createElement(Tag, {
          className: "".concat(cx(styles.tag, tagClassName), " automation_selector_dropdown_async_tags_").concat(id),
          deletable: areTagsDeletable,
          onDelete: _this.removeTag(selectedValue.value)
        }, selectedValue.label);
      });
      return _this;
    }
    _createClass(_withTags, [{
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          value = _this$props4.value,
          tagsWrapperClassName = _this$props4.tagsWrapperClassName,
          id = _this$props4.id,
          rest = _objectWithoutProperties(_this$props4, _excluded);
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(WrapperComponent, _extends({}, rest, {
          value: EMPTY_ARRAY,
          onChange: this.handleChange
        })), /*#__PURE__*/React.createElement("div", {
          className: "".concat(cx(styles.tags, tagsWrapperClassName), " automation_selector_dropdown_async_tag_container_").concat(id)
        }, _map(value, this.renderTag)));
      }
    }]);
    return _withTags;
  }(React.Component), _defineProperty(_class, "propTypes", {
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    tagsWrapperClassName: PropTypes.string,
    areTagsDeletable: PropTypes.bool,
    tagClassName: PropTypes.string,
    id: PropTypes.string
  }), _defineProperty(_class, "defaultProps", {
    value: EMPTY_ARRAY,
    onChange: _noop,
    tagsWrapperClassName: '',
    tagClassName: '',
    areTagsDeletable: true,
    id: ''
  }), _class;
}